import { useQuery } from '@tanstack/react-query';
import { api, GuildSummary } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseMyGuildsReturn {
  guilds: GuildSummary[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useMyGuilds(): UseMyGuildsReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.guilds.my(),
    queryFn: () => api.getMyGuilds(),
  });

  return {
    guilds: data?.guilds ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load your guilds' : null,
    refresh: () => {
      refetch();
    },
  };
}
